"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfDocumentAuditListItemDto = instanceOfPaginatedResponseOfDocumentAuditListItemDto;
exports.PaginatedResponseOfDocumentAuditListItemDtoFromJSON = PaginatedResponseOfDocumentAuditListItemDtoFromJSON;
exports.PaginatedResponseOfDocumentAuditListItemDtoFromJSONTyped = PaginatedResponseOfDocumentAuditListItemDtoFromJSONTyped;
exports.PaginatedResponseOfDocumentAuditListItemDtoToJSON = PaginatedResponseOfDocumentAuditListItemDtoToJSON;
exports.PaginatedResponseOfDocumentAuditListItemDtoToJSONTyped = PaginatedResponseOfDocumentAuditListItemDtoToJSONTyped;
const DocumentAuditListItemDto_1 = require("./DocumentAuditListItemDto");
const PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1 = require("./PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta");
/**
 * Check if a given object implements the PaginatedResponseOfDocumentAuditListItemDto interface.
 */
function instanceOfPaginatedResponseOfDocumentAuditListItemDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfDocumentAuditListItemDtoFromJSON(json) {
    return PaginatedResponseOfDocumentAuditListItemDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfDocumentAuditListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(DocumentAuditListItemDto_1.DocumentAuditListItemDtoFromJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfDocumentAuditListItemDtoToJSON(json) {
    return PaginatedResponseOfDocumentAuditListItemDtoToJSONTyped(json, false);
}
function PaginatedResponseOfDocumentAuditListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(DocumentAuditListItemDto_1.DocumentAuditListItemDtoToJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfDocumentAuditListItemDto.js.map